module.exports = __webpack_public_path__ + "img/acaccess.cf2fe27b.svg";